import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth-slice';
import themeReducer from './theme-slice';
import feedbackReducer from './feedback-slice';
import vaultsReducer from './vaults-slice';
import vaultReducer from './vault-slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    feedback: feedbackReducer,
    vaults: vaultsReducer,
    vault: vaultReducer,
  }
});

export type AdviserPortalRootState = ReturnType<typeof store.getState>;
export type AdviserPortalDispatch = typeof store.dispatch;